
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.53 9.44016L12.53 2.44016C12.3827 2.31389 12.194 2.24625 12 2.25016H9C6.37665 2.25016 4.25 4.37681 4.25 7.00016V17.0002C4.25 19.6235 6.37665 21.7502 9 21.7502H15C17.6234 21.7502 19.75 19.6235 19.75 17.0002V10.0002C19.7534 9.79178 19.6743 9.5905 19.53 9.44016ZM12.75 4.79016L17.21 9.25016H14C13.3096 9.25016 12.75 8.69052 12.75 8.00016V4.79016ZM5.75 17.0002C5.75549 18.7928 7.20735 20.2447 9 20.2502H15C16.7926 20.2447 18.2445 18.7928 18.25 17.0002V10.7502H14C12.4812 10.7502 11.25 9.51894 11.25 8.00016V3.75016H9C7.20735 3.75565 5.75549 5.20751 5.75 7.00016V17.0002Z","fill":"currentColor"}})])
          )
        }
      }
    